// @flow
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'
import styled from 'styled-components'
import type { Question } from 'types/question'
import Checkbox from 'ui/atoms/Checkbox'
import Flex from 'ui/atoms/Flex'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'
import ToggleField from 'ui/molecules/ToggleField'
import { FILE_UPLOAD_QUESTION_EXTENSIONS } from 'utils/constants'

type Props = {
  question: Question,
}

const fileTypeOptions = FILE_UPLOAD_QUESTION_EXTENSIONS.map((extension) => ({
  label: extension,
  value: extension,
}))

const FileExtensionsWrapper = styled.div`
  max-height: 250px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`

function BuilderSideMenuFileExtensions({ question }: Props): React.Node {
  const { selectedItem, setQuestion } = React.useContext(FormBuilderContext)

  const onUpdatedFileTypes = React.useCallback(
    (fileTypes) => {
      setQuestion(selectedItem.id, {
        ...question,
        file_extensions: fileTypes,
      })
    },
    [setQuestion, selectedItem, question]
  )

  const getOnChangeFileTypes = React.useCallback(
    (fileTypeOption) => {
      return () => {
        if (question.file_extensions?.includes(fileTypeOption.value)) {
          onUpdatedFileTypes(
            question.file_extensions.filter(
              (ext) => ext !== fileTypeOption.value
            )
          )
        } else {
          onUpdatedFileTypes([
            ...(question.file_extensions ?? []),
            fileTypeOption.value,
          ])
        }
      }
    },
    [onUpdatedFileTypes, question?.file_extensions]
  )

  const onChangeAllowOnlySpecificFileTypes = React.useCallback(() => {
    setQuestion(selectedItem.id, {
      ...question,
      allow_only_specific_file_types: !question.allow_only_specific_file_types,
    })
  }, [setQuestion, selectedItem, question])

  return (
    <Space>
      <Flex justify="between">
        <Text $semibold>Allow Only Specific File Types</Text>
        <ToggleField
          primary
          label=""
          onChange={onChangeAllowOnlySpecificFileTypes}
          value={question.allow_only_specific_file_types}
        />
      </Flex>
      {question.allow_only_specific_file_types && (
        <>
          <Text $semibold>File Type(s)</Text>
          <FileExtensionsWrapper>
            {fileTypeOptions.map((fileTypeOption) => (
              <div>
                <label>
                  <Checkbox
                    checked={question.file_extensions?.includes(
                      fileTypeOption.value
                    )}
                    className="mx-2"
                    onChange={getOnChangeFileTypes(fileTypeOption)}
                  />
                  <Text className="inline">.{fileTypeOption.label}</Text>
                </label>
              </div>
            ))}
          </FileExtensionsWrapper>
        </>
      )}
    </Space>
  )
}

export default BuilderSideMenuFileExtensions
